import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=35d74ff8&scoped=true&"
import script from "./Form1.vue?vue&type=script&lang=js&"
export * from "./Form1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d74ff8",
  null
  
)

export default component.exports